import React, { useState, useContext } from 'react';
import { IconButton, InputBase, makeStyles, Slide } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import 'emoji-mart/css/emoji-mart.css';
import { Picker as EmojiPicker } from 'emoji-mart';
import moment from 'moment';

import firebase from 'firebase/app';
import { db } from '../utils/firebase';

import { AuthContext } from '../context/AuthContext';
import { UsersContext } from '../context/UsersContext';
import { AppContext } from '../context/AppContext';
import { RoomContext } from '../context/RoomContext';

const useStyles = makeStyles({
  form_container: {
    gridArea: 'f',
    borderTop: '1px solid #ddd',
    background: '#fff',
    position: 'relative',
  },
  form: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  input: {
    flex: 1,
  },
});

export default function MessageForm() {
  const [message, setMessage] = useState('');
  const [isEmoji, setIsEmoji] = useState(false);
  const { currentUser } = useContext(AuthContext);
  const { selectedUser: _selectedUser } = useContext(UsersContext);
  const [selectedUser] = _selectedUser;

  const { snack: _snack } = useContext(AppContext);
  const setSnack = _snack[1];

  const room = useContext(RoomContext);

  const classes = useStyles();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const previousMessage = message;
    setMessage('');
    const roomRef = db.collection('rooms').doc(room);

    if (message.trim() && selectedUser.uid) {
      try {
        const chatRoom = await roomRef.get();

        if (chatRoom.exists) {
          roomRef.collection('messages').add({
            text: message,
            senderId: currentUser.uid,
            unread: true,
            timestamp: moment.utc().format(),
          });
        } else {
          roomRef
            .set({
              roomId: room,
              timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            })
            .then(() => {
              roomRef.collection('messages').add({
                text: message,
                senderId: currentUser.uid,
                unread: true,
                timestamp: moment.utc().format(),
              });
            });
        }
      } catch (err) {
        console.log(err);

        setMessage(previousMessage);
        setSnack({
          open: true,
          status: 'error',
          message: 'Failed to send message! Please try again',
        });
      }
    } else {
      return;
    }
  };

  const addEmoji = (e) => {
    setMessage(message + e.native);
    document.getElementById('message_input').focus();
  };
  return (
    <div className={classes.form_container}>
      <Slide direction='up' in={isEmoji} mountOnEnter unmountOnExit>
        <EmojiPicker
          style={{
            position: 'absolute',
            bottom: '65px',
            left: '5px',
          }}
          onSelect={addEmoji}
        />
      </Slide>
      <form className={classes.form} onSubmit={handleSubmit} autoComplete='off'>
        <IconButton
          disabled={!selectedUser.uid}
          onClick={() => setIsEmoji(!isEmoji)}
        >
          <InsertEmoticonIcon style={{ fontSize: 28 }} />
        </IconButton>
        <InputBase
          className={classes.input}
          placeholder='Type message'
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          disabled={!selectedUser.uid}
          id='message_input'
        />
        <IconButton type='submit' disabled={!selectedUser.uid}>
          <SendIcon />
        </IconButton>
      </form>
    </div>
  );
}
